import React, { useEffect, useState } from 'react'
import Wave from 'react-wavify'
import joinfamily1 from '../../Image/joinfamily1.png';
import joinfamily2 from '../../Image/joinfamily2.png';
import joinfamily3 from '../../Image/joinfamily3.png';
import joinfamily4 from '../../Image/joinfamily4.png';
import joinfamily5 from '../../Image/joinfamily5.png';
import { GoArrowLeft, GoArrowRight, GoDotFill } from 'react-icons/go';

const JoinFamily = () => {
    const requirement = [
        {
          title: "React.js & Node.js",
          image: joinfamily1,
          requiredSkill: [
            'Proficiency in both React.js and Node.js.',
            'Minimum 1 year of hands-on experience in full-stack development.',
            'Strong communication skills.',
            'Minimum Bachelor’s degree in Computer Science or related field.'
          ],
          salary: ['As per industry standards'],
          workingHours: ['9:00 a.m. to 6:00 p.m. (Monday–Friday/Saturday)']
        },
        {
          title: "Laravel & Vue.JS",
          image: joinfamily2,
          requiredSkill: [
            'Experience in Laravel and Vue.js frameworks.',
            'Minimum 1 year of backend and frontend development experience.',
            'Good understanding of RESTful APIs and MVC architecture.',
            'Strong communication skills.',
            'Minimum Bachelor’s degree in Computer Science or related field.'
          ],
          salary: ['As per industry standards'],
          workingHours: ['9:00 a.m. to 6:00 p.m. (Monday–Friday/Saturday)']
        },
        {
          title: "Codeigniter & Laravel",
          image: joinfamily3,
          requiredSkill: [
            'Strong experience in CodeIgniter and Laravel frameworks.',
            'Minimum 1 year of PHP-based web development experience.',
            'Database and ORM familiarity (MySQL, Eloquent).',
            'Strong communication skills.',
            'Minimum Bachelor’s degree in Computer Science or related field.'
          ],
          salary: ['As per industry standards'],
          workingHours: ['9:00 a.m. to 6:00 p.m. (Monday–Friday/Saturday)']
        },
        {
          title: "PHP Team Leader",
          image: joinfamily4,
          requiredSkill: [
            'Excellent knowledge of PHP and popular frameworks like Laravel/CodeIgniter.',
            'Leadership and project management skills.',
            '3+ years of professional experience in PHP development.',
            'Ability to guide junior developers and perform code reviews.',
            'Strong communication and client interaction skills.',
            'Minimum Bachelor’s degree in Computer Science or related field.'
          ],
          salary: ['As per industry standards'],
          workingHours: ['9:00 a.m. to 6:00 p.m. (Monday–Friday/Saturday)']
        },
        {
          title: "Flutter Developer",
          image: joinfamily5,
          requiredSkill: [
            'Proficient in Flutter and Dart for cross-platform mobile app development.',
            'Understanding of state management and app architecture (e.g., Bloc, Provider).',
            'Minimum 1 year of experience building and deploying mobile apps.',
            'Strong problem-solving and communication skills.',
            'Minimum Bachelor’s degree in Computer Science or related field.'
          ],
          salary: ['As per industry standards'],
          workingHours: ['9:00 a.m. to 6:30 p.m. (Monday–Friday/Saturday)']
        }
      ];

    const [activeTab, setActiveTab] = useState(0);

    const goToTab = (id) => {
        setActiveTab(id);
        const tabBtn = document.querySelector(`#requirement${id}-styled-tab`);
        if (tabBtn) tabBtn.click();
    };

    useEffect(() => {
        goToTab(0); // Set default tab on mount
    }, []);

    return (
        <div className='overflow-hidden'>
            <Wave fill='#FFF' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className='relative min-w-[1920px] h-[28px] bg-theme_light' />
            <div className='  py-5'>
                <div className='container py-8'>
                    <div className='text-center  m-auto '>
                        <div className='flex justify-center flex-wrap'>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-[#141414]  leading-[40px] 2xl:leading-[60px]'>LET'S JOIN OUR</h1>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-theme_dark  leading-[40px] 2xl:leading-[60px] ps-2'>FAMILY</h1>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="mb-4 xl:w-[80%] w-full m-auto relative mb-7">
                        <ul
                            className="flex overflow-auto  hide-scrollbar -mb-px text-sm font-medium text-center justify-between relative z-[1]"
                            id="default-styled-tab"
                            data-tabs-toggle="#default-styled-tab-content"
                            data-tabs-active-classes="bg-purple-600 text-white border-purple-600 shadow-purple-md"
                            data-tabs-inactive-classes="bg-white text-gray-700 border-theme_dark"
                            role="tablist"
                        >
                            {requirement?.map((item, id) => (
                                <li
                                    key={id}
                                    className="flex flex-col justify-center items-center w-[200px] relative px-4"
                                    role="presentation"
                                >
                                    <button
                                        className={`xl:h-[90px] xl:w-[90px] h-[70px] w-[70px] rounded-full border flex justify-center items-center transition-all duration-300 xl:p-0 p-3 ${activeTab === id ? 'bg-purple-600 text-white border-purple-600 shadow-purple-md' : 'bg-white text-gray-700 border-theme_dark' }`}
                                        id={`requirement${id}-styled-tab`}
                                        data-tabs-target={`#styled-requirement${id}`}
                                        type="button"
                                        role="tab"
                                        aria-controls={`styled-requirement${id}`}
                                        onClick={() => goToTab(id)}
                                    >
                                        <img src={item.image} alt={item.title} data-aos="flip-left" />
                                    </button>
                                    {id !== requirement.length - 1 && (
                                        <div className="absolute top-[37%] xl:left-[145px] left-[110px] xl:w-[90%] w-full h-[7px] bg-purple-500 z-[-1]"></div>
                                    )}
                                    <h6 className="font-bold text-nowrap mt-3">{item.title}</h6>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div id="default-styled-tab-content">
                        {requirement?.map((item, id) => (
                            <div
                                key={id}
                                className={`rounded-lg bg-gray-50  bg-theme_light ${activeTab === id ? '' : 'hidden'
                                    }`}
                                id={`styled-requirement${id}`}
                                role="tabpanel"
                                aria-labelledby={`requirement${id}-styled-tab`}
                            >
                                <div className="bg-theme_dark text-center rounded-[10px]">
                                    <h1 className="uppercase text-xl sm:text-2xl 2xl:text-3xl font-bold text-white leading-[30px] 2xl:leading-[66px] xl:py-0 py-3">
                                        {item.title}
                                    </h1>
                                </div>

                                <div className="md:text-center p-5 relative">

                                    <div className="pb-5">
                                        <h5 className="text-[#141414] font-semibold text-xl sm:text-2xl 2xl:text-2xl m-auto p-2 text-center">
                                            Required skills:
                                        </h5>
                                        <ul className="list-disc">
                                            {item.requiredSkill.map((skill, ind) => (
                                                <li key={ind} className="flex md:justify-center ">
                                                    <GoDotFill className="w-[10px] min-w-[10px] lg:me-3 me-2 mt-1" />
                                                    <span className='md:text-[16px] text-[14px]'>{skill}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="pb-5">
                                        <h5 className="text-[#141414] font-semibold text-xl text-xl sm:text-2xl 2xl:text-2xl m-auto text-center">
                                            Salary:
                                        </h5>
                                        <ul className="list-disc">
                                            {item.salary.map((sal, ind) => (
                                                <li key={ind} className="flex md:justify-center ">
                                                    <GoDotFill className="w-[10px] min-w-[10px] lg:me-3 me-2 mt-1" />
                                                    <span className='md:text-[16px] text-[14px]'>{sal}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="pb-5">
                                        <h5 className="text-[#141414] font-semibold text-xl sm:text-2xl 2xl:text-2xl m-auto text-center">
                                            Working Hours:
                                        </h5>
                                        <ul className="list-disc">
                                            {item.workingHours.map((hour, ind) => (
                                                <li key={ind} className="flex md:justify-center ">
                                                    <GoDotFill className="w-[10px] min-w-[10px] lg:me-3 me-2 mt-1" />
                                                    <span className='md:text-[16px] text-[14px]'>{hour}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="md:absolute md:top-[50%] top-0 left-0 md:translate-y-[-50%] flex w-full md:justify-between justify-end md:px-5">
                                        {activeTab > 0 ? (
                                            <button
                                                onClick={() => goToTab(activeTab - 1)}
                                                className="md:mx-0 mx-1 bg-theme_dark md:h-[50px] md:w-[50px] h-[30px] w-[30px] rounded-full flex justify-center items-center text-white cursor-pointer hover:bg-theme_light hover:border hover:border-theme_dark hover:text-theme_dark transition"
                                            >
                                                <GoArrowLeft className="md:w-[30px] md:h-[30px] h-[20px] w-[20px]" />
                                            </button>
                                        ) : (
                                            null
                                        )}

                                        {activeTab < requirement.length - 1 ? (
                                            <button
                                                onClick={() => goToTab(activeTab + 1)}
                                                className="md:ms-auto  md:mx-0 mx-1 bg-theme_dark md:h-[50px] md:w-[50px] h-[30px] w-[30px] rounded-full flex justify-center items-center text-white cursor-pointer hover:bg-theme_light hover:border hover:border-theme_dark hover:text-theme_dark transition"
                                            >
                                                <GoArrowRight className="md:w-[30px] md:h-[30px] h-[20px] w-[20px]" />
                                            </button>
                                        ) : (
                                            null
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JoinFamily
